/**
 * Admin Offer Refund Handler
 *
 * Handles refund button clicks and AJAX requests for one-click offer refunds.
 *
 * @since 10.4.0
 */

declare const cfwOfferRefund: {
    ajaxUrl: string;
    nonce: string;
    i18n: {
        confirmRefund: string;
        processing: string;
        refunded: string;
    };
};

jQuery( document ).ready( function ( $ ) {
    'use strict';

    /**
     * Handle refund button clicks
     */
    $( document ).on( 'click', '.cfw-refund-offer-button', function ( e ) {
        e.preventDefault();

        const $button = $( this );
        const orderId = $button.data( 'order-id' );
        const bumpId = $button.data( 'bump-id' );
        const itemId = $button.data( 'item-id' );
        const productName = $button.data( 'product-name' );

        // Confirm refund
        if ( ! confirm( cfwOfferRefund.i18n.confirmRefund ) ) {
            return;
        }

        // Disable button and show loading state
        $button.prop( 'disabled', true );
        $button.addClass( 'cfw-refunding' );
        $button.text( cfwOfferRefund.i18n.processing );

        // Send AJAX request
        $.ajax( {
            url: cfwOfferRefund.ajaxUrl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'cfw_admin_refund_offer',
                _wpnonce: cfwOfferRefund.nonce,
                order_id: orderId,
                bump_id: bumpId,
                item_id: itemId,
            },
        } )
            .done( function ( response ) {
                if ( response.success ) {
                    // Update UI to show refunded state
                    $button.removeClass( 'cfw-refunding' );
                    $button.replaceWith(
                        '<span class="cfw-offer-refunded">' + cfwOfferRefund.i18n.refunded + '</span>'
                    );

                    // Show success message
                    if ( response.data && response.data.message ) {
                        alert( response.data.message );
                    }

                    // Trigger custom event for other scripts to listen to
                    $( document ).trigger( 'cfw_offer_refunded', {
                        orderId,
                        bumpId,
                        itemId,
                        productName,
                    } );
                } else {
                    // Show error message
                    const errorMessage = response.data && response.data.message
                        ? response.data.message
                        : 'An error occurred while processing the refund.';
                    alert( errorMessage );

                    // Re-enable button
                    $button.prop( 'disabled', false );
                    $button.removeClass( 'cfw-refunding' );
                    $button.text( 'Refund' );
                }
            } )
            .fail( function () {
                alert( 'An error occurred while processing the refund. Please try again.' );

                // Re-enable button
                $button.prop( 'disabled', false );
                $button.removeClass( 'cfw-refunding' );
                $button.text( 'Refund' );
            } );
    } );
} );
